//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.AECDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../Features/Features.AECDesign.LevelReferenceBuilder.js";
import "../Features/Features.AECDesign.MaterialStairBuilder.js";
import "../no/Features.js";
import "../no/Expression.js";
let d=[[[1,"AlignmentOffsetDim",0,"Expression",0],[0,"AlignmentType",1,0],[1,"BottomLevel",0,"Features.AECDesign.LevelReferenceBuilder",0],[0,"EndPoint",1,"Point",0],[1,"FullSpiralAngleDim",0,"Expression",0],[1,"LeftCarriageOffsetDim",0,"Expression",0],[1,"LeftStringerDepthDim",0,"Expression",0],[0,"LeftSupportType",1,0],[1,"MaterialStair",0,"Features.AECDesign.MaterialStairBuilder",0],[0,"MiddleCarriage",1,0],[1,"MinimumHeadroomDim",0,"Expression",0],[1,"PartialSpiralAngleDim",0,"Expression",0],[0,"ReverseOffsetDirection",1,0],[1,"RightCarriageOffsetDim",0,"Expression",0],[1,"RightStringerDepthDim",0,"Expression",0],[0,"RightSupportType",1,0],[1,"RiserNumberExp",0,"Expression",0],[1,"RunWidthDim",0,"Expression",0],[0,"StartPoint",1,"Point",0],[0,"TerminationType",1,0],[1,"TopLevel",0,"Features.AECDesign.LevelReferenceBuilder",0],[0,"TopLevelOpening",1,0],[1,"TreadDepthDim",0,"Expression",0],[0,"TrimStringerAtTopLevel",1,0],[0,"TurnDirection",1,0],[0,"Type",1,0]],[[[],"AddNewStartEndPointPair",{},0,0],[["size"],"GetStartEndPointPairs",{R_:{pointPairs:""}},0,0],[["pointPairs"],"SetStartEndPointPairs",{},1,0]],[]];
SPLM.Features.AECDesign.StairBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.AECDesign.StairBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.AECDesign.StairBuilder.PointPair = class{
    constructor(startPoint,endPoint){
        this.startPoint=startPoint;this.endPoint=endPoint;}
    get Startpoint(){return this.startPoint}
    set Startpoint(val){this.startPoint = val}
    get Endpoint(){return this.endPoint}
    set Endpoint(val){this.endPoint = val}
};

SPLM.Features.AECDesign.StairBuilder.StairTypes = Object.freeze({
    "Straight" : "Straight", "StraightWithLandings" : "StraightWithLandings", "FullSpiral" : "FullSpiral", "PartialSpiral" : "PartialSpiral", "LShapedWinder" : "LShapedWinder", "UShapedWinder" : "UShapedWinder"});

SPLM.Features.AECDesign.StairBuilder.SupportTypes = Object.freeze({
    "None" : "None", "Carriage" : "Carriage", "Stringer" : "Stringer"});

SPLM.Features.AECDesign.StairBuilder.AlignmentTypes = Object.freeze({
    "LeftExteriorSupport" : "LeftExteriorSupport", "Left" : "Left", "Center" : "Center", "Right" : "Right", "RightExteriorSupport" : "RightExteriorSupport"});

SPLM.Features.AECDesign.StairBuilder.TerminationTypes = Object.freeze({
    "EndWithRiser" : "EndWithRiser", "EndWithTread" : "EndWithTread"});

SPLM.Features.AECDesign.StairBuilder.TurnDirectionTypes = Object.freeze({
    "RightHand" : "RightHand", "LeftHand" : "LeftHand"});

export default SPLM;